import { Component } from '@angular/core';
import { AuthDisplayerService } from 'src/app/application/usesCases/auth-displayer.service';
import { Router } from '@angular/router';
import { BaseResponse } from 'src/app/domain/models/base-response.model';
@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss']
})
export class PasswordRecoveryComponent {
  disabledButton: boolean = true;
  userName!: string;
  errorToastOptions = {
    isShowing : false,
    toastTime : 5000
  }
  succesToastOptions = {
    isShowing : false,
    toastTime : 5000
  }

  constructor(
    private authDisplayerService: AuthDisplayerService,
    private router: Router,
    ){}

  onChangeNewUser(event : Event): void{
    this.userName = (event as CustomEvent).detail;
    this.disabledButton = !this.validFiels();
  }

  sendUser(): void{
    this.authDisplayerService
      .askForgotPassword(this.userName)
      .subscribe({
        next: (res: BaseResponse) => {
          this.showSuccesToast();
          this.disabledButton = true;
          setTimeout(() => {
            this.router.navigateByUrl('/');
          }, 5000);
        },
        error: (error: any) => {
          this.showErrorToast();
        },
      });
  }

  validFiels(): boolean {
    if (this.userName == '' || this.userName.length < 3) return false;
    else return true
  }

  showErrorToast(): void {
    this.errorToastOptions.isShowing = true;
  }

  closingErrorToast(): void{
    this.errorToastOptions.isShowing = false;
  }

  showSuccesToast(): void {
    this.succesToastOptions.isShowing = true;
  }

  closingSuccesToast(): void{
    this.succesToastOptions.isShowing = false;
  }
}
